// extracted by mini-css-extract-plugin
export var logo = "_bs-2";
export var logoWrapper = "_bs-1";
export var strip = "_bs-0";